import { render, staticRenderFns } from "./noLayout.vue?vue&type=template&id=30f1cd9d&scoped=true"
import script from "./noLayout.vue?vue&type=script&lang=js"
export * from "./noLayout.vue?vue&type=script&lang=js"
import style0 from "./noLayout.vue?vue&type=style&index=0&id=30f1cd9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1cd9d",
  null
  
)

export default component.exports